import { motion } from 'framer-motion';
import { X, CheckCircle2, RefreshCw } from 'lucide-react';
import FounderAvatar from '@/components/brand/FounderAvatar';
import SocialRow from '@/components/brand/SocialRow';
import StoreBadges from '@/components/brand/StoreBadges';
import { FOUNDER } from '@/lib/brand';

interface Props {
    onClose: () => void;
    onRestart: () => void;
}

const ThankYouScreen = ({ onClose, onRestart }: Props) => (
    <div className="bg-card/95 backdrop-blur-xl rounded-3xl border border-white/10 shadow-2xl shadow-black/50 overflow-hidden flex flex-col h-[700px]" dir="rtl">
        <div className="px-4 py-3 border-b border-white/10 flex items-center justify-between bg-gradient-to-r from-primary/10 to-secondary/10">
            <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-500" />
                <h3 className="font-bold text-foreground text-sm">تم إرسال طلبك!</h3>
            </div>
            <button
                onClick={onClose}
                className="p-2 rounded-lg hover:bg-white/5 transition-colors text-muted-foreground hover:text-foreground"
                aria-label="إغلاق"
            >
                <X className="w-4 h-4" />
            </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-8 flex flex-col items-center text-center">
            <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: 'spring', bounce: 0.5 }}
                className="mb-5 shadow-xl shadow-primary/30 rounded-full"
            >
                <FounderAvatar size={80} ringBorder />
            </motion.div>

            <motion.h2
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.15 }}
                className="text-xl font-black text-foreground mb-1"
            >
                شكراً لتواصلك! 🙏
            </motion.h2>
            <motion.p
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.25 }}
                className="text-sm text-muted-foreground mb-6 max-w-xs leading-relaxed"
            >
                سيتواصل معك <span className="text-foreground font-bold">{FOUNDER.nameAr}</span> خلال 24 ساعة كحد أقصى.
            </motion.p>

            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.35 }}
                className="w-full mb-6"
            >
                <p className="text-xs text-muted-foreground mb-3 font-bold">تابع المؤسس للحصول على جديدنا:</p>
                <SocialRow variant="cta" channels={['linkedin', 'telegram']} className="mb-3" />
                <SocialRow variant="pill" channels={['youtube', 'facebook']} />
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.45 }}
                className="w-full"
            >
                <p className="text-xs text-muted-foreground mb-3 font-bold">جرّب تطبيقاتنا:</p>
                <StoreBadges size="sm" />
            </motion.div>
        </div>

        <div className="p-3 border-t border-white/10">
            <button
                onClick={onRestart}
                className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-foreground hover:bg-white/10 hover:border-white/20 font-bold text-sm transition-all flex items-center justify-center gap-2"
            >
                <RefreshCw className="w-4 h-4" />
                بدء محادثة جديدة
            </button>
        </div>
    </div>
);

export default ThankYouScreen;
